import { render } from "./tables.vue?vue&type=template&id=70513236"
import script from "./tables.vue?vue&type=script&lang=js"
export * from "./tables.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/system-jj-frontend/system-jj-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__